import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActiveTabState {
  activeTab: string;
}

const initialState: ActiveTabState = {
  activeTab: "week1",
};

const activeTabSlice = createSlice({
  name: "birthdayActiveTab",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },
    resetActiveTab: (state) => {
      state.activeTab = "week1";
    },
  },
});

export const { setActiveTab, resetActiveTab } = activeTabSlice.actions;

export default activeTabSlice.reducer;
